export function calculateTotalAmount(data: any[]) {
  return data.reduce((acc, row) => acc + parseFloat(row.amountPaid || "0"), 0);
}
